import React from "react";
import SubscribeSetting from "components/pages/transmissions/modal/patient/tabs/subscription/setting/SubscribeSetting";
import SubscriptionLogTable from "components/pages/transmissions/modal/patient/tabs/subscription/log/SubscriptionLogTable";

const Subscription = () => {
  return (
    <>
      <div
        className="patient-modal__aside-container"
        style={{ marginBottom: "15px" }}
      >
        <SubscribeSetting />
      </div>
      <div
        className="patient-modal__aside-container"
        style={{ marginBottom: "15px" }}
      >
        <SubscriptionLogTable title="Reminders/Live Calls" type="twilio" />
      </div>
    </>
  );
};

export default Subscription;
